import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SearchType } from './avano-search-toggle.common';

export const AVANO_TOGGLE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AvanoSearchToggleComponent),
  multi: true
};

@Component({
  selector: 'avano-search-toggle',
  templateUrl: './avano-search-toggle.component.html',
  styleUrls: ['./avano-search-toggle.component.scss'],
  providers: [AVANO_TOGGLE_VALUE_ACCESSOR],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoSearchToggleComponent implements ControlValueAccessor {
  @Input() quickLabel = 'Quick'; // If internationalized, provide translation from outside
  @Input() advancedLabel = 'Advanced'; // If internationalized, provide translation from outside

  // Not official supported according to avano, but both applications placed the search toggle before implementing the whole advanced search.
  @Input() disableAdvanced = false; // To be able to place a search toggle but not implement advanced search, deactive advanced option

  disabled: boolean;

  @Output() onOptionClick: EventEmitter<any> = new EventEmitter();

  @Output() onChange: EventEmitter<any> = new EventEmitter();

  value: any;

  public searchType: typeof SearchType = SearchType;

  onModelChange: Function = () => {};

  onModelTouched: Function = () => {};

  constructor(public cd: ChangeDetectorRef) {}

  writeValue(value: any): void {
    this.value = value;
    this.cd.markForCheck();
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
    this.cd.markForCheck();
  }

  onItemClick(event, option: any) {
    this.value = option;

    this.onOptionClick.emit({
      originalEvent: event,
      option: option
    });

    this.onModelChange(this.value);

    this.onChange.emit({
      originalEvent: event,
      value: this.value
    });
  }

  onBlur() {
    this.onModelTouched();
  }
}
